import { render, staticRenderFns } from "./cms-block-menu.vue?vue&type=template&id=084b8132&scoped=true"
import script from "./cms-block-menu.vue?vue&type=script&lang=js"
export * from "./cms-block-menu.vue?vue&type=script&lang=js"
import style0 from "./cms-block-menu.vue?vue&type=style&index=0&id=084b8132&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084b8132",
  null
  
)

export default component.exports